import React from 'react';

import PhoneEntryStep from './PhoneEntryStep';
import CodeVerificationStep from './CodeVerificationStep';
import { FormLayout } from '../../layout';

const CustomPhoneMFA = ({
  smsCodeSent,
  smsPhoneNumber,
  isVerifyMode,
  onSendCode,
  onResendCode,
  onSubmitCode,
  onPickDifferentMethod,
  error,
  isSubmitting,
}) => {
  const showCodeStep = isVerifyMode || smsCodeSent;

  return (
    <FormLayout>
      {showCodeStep ? (
        <CodeVerificationStep
          phoneDisplayNumber={smsPhoneNumber || ''}
          isVerifyMode={isVerifyMode}
          onSubmitCode={onSubmitCode}
          onResendCode={onResendCode}
          onPickDifferentMethod={onPickDifferentMethod}
          error={error}
          isSubmitting={isSubmitting}
        />
      ) : (
        <PhoneEntryStep
          onSendCode={onSendCode}
          onPickDifferentMethod={onPickDifferentMethod}
          error={error}
          isSubmitting={isSubmitting}
        />
      )}
    </FormLayout>
  );
};

export default CustomPhoneMFA;
